import { render, staticRenderFns } from "./GatMultiSelect.vue?vue&type=template&id=455b5a38&scoped=true&"
import script from "./GatMultiSelect.vue?vue&type=script&lang=js&"
export * from "./GatMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b5a38",
  null
  
)

export default component.exports